export default __webpack_public_path__ + "static/media/roadmap-q4.3648dfcf.png";